/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Cell } from "react-table";
import { Text } from "@nordcloud/gnui";
import { CostForecastHeader } from "~/components";
import {
  ApplicationCell,
  EstateCostCell,
  ProviderCell,
  ResourceNameCell,
} from "~/components/Tables/Cells";
import { useConsoleUrl } from "~/hooks";
import { Estate } from "../../components/types";

export const ACCOUNT_DETAILS_ESTATE_COLUMNS = [
  {
    Header: "",
    accessor: "provider",
    disableSortBy: true,
    width: "1rem",
    Cell: ({ row }: Cell<Estate>) => (
      <ProviderCell provider={row.original.provider} />
    ),
  },
  {
    Header: "Resource name / Resource type",
    accessor: "nordcloudId",
    disableSortBy: true,
    width: "30rem",
    Cell: ({ row }: Cell<Estate>) => {
      const {
        type,
        cloudAccountId,
        name,
        id,
        nordcloudId,
        provider,
        category,
      } = row.original;

      const { url } = useConsoleUrl({
        ...row.original,
        cloudAccountId: cloudAccountId ?? "",
      });

      return (
        <ResourceNameCell
          id={id}
          nordcloudId={nordcloudId}
          name={name}
          type={type}
          category={category}
          url={url}
          provider={provider}
        />
      );
    },
  },
  {
    Header: "Region",
    accessor: "region",
    disableSortBy: true,
    width: "10rem",
    Cell: ({ row }: Cell<Estate>) => (
      <Text tag="div">{row.original.region}</Text>
    ),
  },
  {
    Header: "Application / Environment",
    accessor: "application",
    disableSortBy: true,
    width: "25rem",
    Cell: ({ row }: Cell<Estate>) => (
      <ApplicationCell
        environment={row.original.environment}
        assignments={row.original.assignments}
      />
    ),
  },
  {
    Header: <CostForecastHeader>Cost / Forecast</CostForecastHeader>,
    accessor: "actualCosts",
    disableSortBy: true,
    width: "10rem",
    Cell: ({ row }: Cell<Estate>) => (
      <EstateCostCell
        estateId={row.original.id}
        isWaste={row.original.isWaste}
        reason={row.original.reason}
        value={row.original.actualCosts}
        amount={row.original.savingsAmount}
        count={row.original.savingsAmountCount ?? 0}
        extraInfo={row.original.forecast}
        co2e={parseFloat(row.original.co2e)}
        co2eSavings={parseFloat(row.original.co2eSavings)}
      />
    ),
  },
];
